import { AutoComplete, Button, Input, Modal, Select, Tag, Tooltip } from "antd";
import { useState } from "react";
import {
  classification_select,
  position_select,
  seniority_select,
  state_select,
} from "Benchmarking/Config/SelectData";
import "Benchmarking/Scss/SearchAdvanceFaculty.scss";
import { getFacultySuggestSearch } from "Benchmarking/Services/Author";
import { getDepartmentSuggestSearch } from "Benchmarking/Services/Department";
import { getInstitutionSuggestSearch } from "Benchmarking/Services/Institution";

const SearchAdvanceFaculty = ({ filters, setFilters }) => {
  const [tempFilters, setTempFilters] = useState({});
  const [facultyOptions, setFacultyOptions] = useState([]);
  const [currentSearchQueryValue, setCurrentSearchQueryValue] = useState("");
  const [institutionOptions, setInstitutionOptions] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [openAdd, setOpenAdd] = useState(false);

  const tagRenderForSelect = (props) => {
    const { label, value, closable, onClose } = props;
    const onPreventMouseDown = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };
    const isLongTag = label.length > 10;
    const tagElem = (
      <Tag
        // bordered={false}
        style={{
          background: "var(--benchmarking-color)",
          color: "white",
          userSelect: "none",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          border: "none",
          height: "28px",
        }}
        onMouseDown={onPreventMouseDown}
        closable={closable}
        onClose={onClose}
      >
        {isLongTag ? `${label.slice(0, 10)}...` : label}
      </Tag>
    );
    return (
      <>{isLongTag ? <Tooltip title={label}>{tagElem}</Tooltip> : tagElem}</>
    );
  };

  const handleInputChangeFaculty = (value) => {
    if (value) {
      getFacultySuggestSearch(value, (res) => {
        setFacultyOptions(
          res.map((item) => {
            return {
              ...item,
              value: item.name,
            };
          })
        );
      });
      setCurrentSearchQueryValue(value);
    } else {
      setFilters({ ...filters, query: null });
      setCurrentSearchQueryValue("");
    }
  };

  const handleInputConfirmFaculty = (value, option) => {
    setFilters({
      ...filters,
      query: `${option.name}`,
    });
  };
  const onChangePosition = (value) => {
    setTempFilters({
      ...tempFilters,
      positions: value,
    });
  };
  const onChangeSeniority = (value) => {
    setTempFilters({
      ...tempFilters,
      seniorities: value,
    });
  };

  const onChangeInstitution = (value) => {
    setTempFilters({
      ...tempFilters,
      institutions: value,
    });
  };
  const onChangeDepartment = (value) => {
    setTempFilters({
      ...tempFilters,
      departments: value,
    });
  };
  const onChangeClassification = (value) => {
    setTempFilters({
      ...tempFilters,
      classifications: value,
    });
  };
  const onChangeState = (value) => {
    setTempFilters({
      ...tempFilters,
      states: value,
    });
  };

  const filterOption = (input, option) =>
    (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  const handleOnSearchInstitution = (value) => {
    if (value) {
      getInstitutionSuggestSearch(value, (res) => {
        let option_list = res.map((item) => {
          return {
            ...item,
            value: item.name,
            label: item.name,
          };
        });
        option_list = [
          {
            value: value,
            label: value,
          },
          ...option_list,
        ];
        setInstitutionOptions(option_list);
      });
    }
  };
  const handleOnSearchDepartment = (value) => {
    if (value) {
      getDepartmentSuggestSearch(value, (res) => {
        let option_list = res.map((item) => {
          return {
            ...item,
            value: item.name,
            label: item.name,
          };
        });
        option_list = [
          {
            value: value,
            label: value,
          },
          ...option_list,
        ];
        setDepartmentOptions(option_list);
      });
    }
  };
  const handleApplyFilters = () => {
    setOpenAdd(false);
    setFilters({
      ...filters,
      ...tempFilters,
    });
  };

  const tagRender = (label, closable, onClose) => {
    const onPreventMouseDown = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };
    const isLongTag = label.length > 10;
    const tagElem = (
      <Tag
        style={{
          background: "var(--benchmarking-color)",
          color: "white",
          userSelect: "none",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          border: "none",
        }}
        onMouseDown={onPreventMouseDown}
        closable={closable}
        onClose={onClose}
      >
        {isLongTag ? `${label.slice(0, 10)}...` : label}
      </Tag>
    );
    return (
      <>{isLongTag ? <Tooltip title={label}>{tagElem}</Tooltip> : tagElem}</>
    );
  };
  return (
    <div className="search-advanced-faculty">
      <Modal
        title={<p className="title-search-advance">Advanced Search</p>}
        open={openAdd}
        onCancel={() => setOpenAdd(false)}
        width={650}
        centered={true}
        footer={[
          <Button key="back" onClick={() => setOpenAdd(false)}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={handleApplyFilters}>
            Apply
          </Button>,
        ]}
      >
        <div className="affilication">
          <p className="sub-title-search-advance">Personal</p>
          <Select
            className="filter-item"
            showSearch
            placeholder="Position"
            optionFilterProp="children"
            mode="multiple"
            allowClear
            tagRender={tagRenderForSelect}
            onChange={onChangePosition}
            filterOption={filterOption}
            options={position_select}
            style={{ width: "100%", marginBottom: "10px", height: "40px" }}
          />
          <Select
            mode="multiple"
            allowClear
            className="filter-item"
            showSearch
            tagRender={tagRenderForSelect}
            placeholder="Seniority"
            optionFilterProp="children"
            onChange={onChangeSeniority}
            filterOption={filterOption}
            options={seniority_select}
            style={{ width: "100%", height: "40px" }}
          />
        </div>
        <div className="affilication">
          <p className="sub-title-search-advance">Affiliation</p>
          <Select
            mode="multiple"
            allowClear
            className="filter-item"
            showSearch
            tagRender={tagRenderForSelect}
            placeholder="Institution"
            optionFilterProp="children"
            onSearch={handleOnSearchInstitution}
            onChange={onChangeInstitution}
            filterOption={filterOption}
            options={institutionOptions}
            style={{ width: "100%", marginBottom: "10px", height: "40px" }}
          />
          <Select
            mode="multiple"
            allowClear
            className="filter-item"
            showSearch
            tagRender={tagRenderForSelect}
            placeholder="Department"
            optionFilterProp="children"
            onSearch={handleOnSearchDepartment}
            onChange={onChangeDepartment}
            filterOption={filterOption}
            options={departmentOptions}
            style={{ width: "100%", marginBottom: "10px", height: "40px" }}
          />
          <Select
            mode="multiple"
            allowClear
            className="filter-item"
            showSearch
            tagRender={tagRenderForSelect}
            placeholder="Classification"
            optionFilterProp="children"
            onChange={onChangeClassification}
            filterOption={filterOption}
            options={classification_select}
            style={{ width: "100%", marginBottom: "10px", height: "40px" }}
          />
          <Select
            mode="multiple"
            allowClear
            className="filter-item"
            showSearch
            tagRender={tagRenderForSelect}
            placeholder="State"
            optionFilterProp="children"
            onChange={onChangeState}
            filterOption={filterOption}
            options={state_select}
            style={{ width: "100%", height: "40px" }}
          />
        </div>
      </Modal>
      <div className="search-section">
        <div className="search-bar">
          <AutoComplete
            options={facultyOptions}
            placeholder="Enter to search"
            onChange={handleInputChangeFaculty}
            onSelect={handleInputConfirmFaculty}
            style={{ width: "100%" }}
          >
            <Input
              style={{ height: "40px" }}
              onPressEnter={() => {
                setFilters({ ...filters, query: currentSearchQueryValue });
              }}
            />
          </AutoComplete>
        </div>
        <div
          className="advanced-search-button"
          onClick={() => setOpenAdd(true)}
        >
          <p>Advanced Search</p>
        </div>
      </div>
      <div className="filters-search-modal">
        {filters.positions && (
          <div className="group-filters">
            <p>Position: </p>
            {filters.positions.map((item) => tagRender(item, null, null))}
          </div>
        )}
        {filters.seniorities && (
          <div className="group-filters">
            <p>Seniority: </p>
            {filters.seniorities.map((item) =>
              tagRender(seniority_select[item - 1].label, null, null)
            )}
          </div>
        )}
        {filters.institutions && (
          <div className="group-filters">
            <p>Institution: </p>
            {filters.institutions.map((item) => tagRender(item, null, null))}
          </div>
        )}
        {filters.departments && (
          <div className="group-filters">
            <p>Department: </p>
            {filters.departments.map((item) => tagRender(item, null, null))}
          </div>
        )}
        {filters.classifications && (
          <div className="group-filters">
            <p>Classification: </p>
            {filters.classifications.map((item) => tagRender(item, null, null))}
          </div>
        )}
        {filters.states && (
          <div className="group-filters">
            <p>States: </p>
            {filters.states.map((item) => tagRender(item, null, null))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchAdvanceFaculty;
